/**
 * Save status bus — singleton event-based.
 *
 * Filosofia: i mutation HTTP (POST/PUT/PATCH/DELETE) emettono "saving"
 * all'inizio e "saved" / "error" alla fine. Un componente UI globale ascolta
 * questi eventi e mostra un piccolo indicatore che svanisce dopo 1.5s.
 *
 * Implementato come module-level state + CustomEvent su window, senza React
 * context (così è agnostico rispetto al renderer e non causa re-render
 * inutili nei consumer).
 */
const EVT = 'qp:save-status';

let inflight = 0;
let lastSavedAt = 0;

function emit(state, extra = {}) {
  window.dispatchEvent(new CustomEvent(EVT, { detail: { state, inflight, lastSavedAt, ...extra } }));
}

export function notifySaving() {
  inflight += 1;
  emit('saving');
}

export function notifySaved() {
  inflight = Math.max(0, inflight - 1);
  lastSavedAt = Date.now();
  emit(inflight === 0 ? 'saved' : 'saving');
}

export function notifyError(message) {
  inflight = Math.max(0, inflight - 1);
  emit(inflight === 0 ? 'error' : 'saving', { message });
}

export function subscribe(listener) {
  const handler = (e) => listener(e.detail);
  window.addEventListener(EVT, handler);
  return () => window.removeEventListener(EVT, handler);
}

export function getInflight() {
  return inflight;
}
